function addSpace(nStr) {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ' ' + '$2');
    }
    return x1 + x2;
}

const countFloat = x => ( (String(x).includes('.')) ? (String(x).split('.').pop().length) : (0) );

var investorSlider = $("#investor-slider");
var investorSliderValue = $('#investor-slider-value');
var investorSliderResult = $('#investor-slider-result');
var investorSliderPerMonth = $('#investor-slider-per-month');
var tariffSelector = $('input[name=tariff-select]');
var selectedTariff = $('input[name=tariff-select]:checked');

if (investorSliderValue.length > 0) {
    investorSliderValue.val(addSpace(Number(investorSliderValue.val().replace(/\s+/g, ''))));
}

investorSlider.ionRangeSlider({
    type: "single",
    min: 0,
    max: 60,
    step: 1,
    grid: true,
    grid_num: 5,
    from_min: 1,
    hide_min_max: true,
    postfix: investorSlider.data('suffix'),
    from: 30,
    skin: "round",
    onStart: function (data) {
        calculateDividends();
        $('.irs-grid-text').get(0).innerHTML = 1;
    },
    onChange: function (data) {
        calculateDividends();
        $('.irs-single').append('<div class="position-relative irs-second-single"></div>');
        appendSecondTooltip();
    },
});

function roundTo(n, digits) {
    if (digits === undefined) {
        digits = 0;
    }

    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    return Math.round(n) / multiplicator;
}

investorSliderValue.on('input', function() {
    calculateDividends();
    appendSecondTooltip();
    investorSliderValue.val(addSpace(Number(investorSliderValue.val().replace(/\s+/g, ''))));
});

tariffSelector.on('change', function () {
    selectedTariff = $('input[name=tariff-select]:checked');
    calculateDividends();
    appendSecondTooltip();
});

$('.irs-single').append('<div class="position-relative irs-second-single"></div>');
appendSecondTooltip();

function calculateDividends() {
    var min = Number(selectedTariff.data('min'));
    var max = Number(selectedTariff.val());
    var yearPercentDelta = (max - min) / 59;
    var additionalPercent = roundTo((yearPercentDelta * (investorSlider.val() - 1)), 2);
    var yearPercent = min + additionalPercent;
    var monthPercent = roundTo((yearPercent / 12), 2);

    var investSum = Number(investorSliderValue.val().replace(/\s+/g, ''));
    var dividendsPerMonth = (investSum * monthPercent / 100);
    investorSliderPerMonth.val(roundTo(dividendsPerMonth, 2));
    var dividendsPerYear = dividendsPerMonth * investorSlider.val();
    dividendsPerYear = roundTo(dividendsPerYear, 2);
    dividendsPerYear = countFloat(dividendsPerYear) == 1 ? dividendsPerYear + '0' : dividendsPerYear;
    dividendsPerYear = countFloat(dividendsPerYear) == 0 ? dividendsPerYear + '.00' : dividendsPerYear;
    investorSliderResult.html(addSpace(dividendsPerYear));

    // Управление свечением
    $('.investor-calculator-inner-highlight').css('opacity', 0.0167 * investorSlider.val())
}

function appendSecondTooltip() {
    var value = investorSliderPerMonth.val();
    value = countFloat(value) == 1 ? value + '0' : value;
    value = countFloat(value) == 0 ? value + '.00' : value;
    value = addSpace(value);
    $('#investor-slider .irs-second-single').html('<div class="irs-second-single-caption"><span id="investor-slider-month-result">' + value + '</span> ' + investorSlider.data('second-suffix') + '</div>');
}